const S3Uploader = function (entries, onViewError) {
  entries.forEach((entry) => {
    let { url, headers, type } = entry.meta;
    // let sizePromise;

    // if (type.startsWith('image/')) {
    //   const img = new Image();

    //   sizePromise = new Promise((resolve, reject) => {
    //     img.onload = () => {
    //       const width = img.naturalWidth;
    //       const height = img.naturalHeight;

    //       URL.revokeObjectURL(img.src);
    //       resolve({ width, height });
    //     };
    //     img.onerror = reject;
    //   });
    //   img.src = URL.createObjectURL(entry.file);
    // } else {
    //   sizePromise = new Promise((resolve, reject) => reject());
    // }

    let xhr = new XMLHttpRequest();
    onViewError(() => xhr.abort());
    xhr.onload = () => (xhr.status === 200 ? entry.progress(100) : entry.error());
    xhr.onerror = () => entry.error();
    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        let percent = Math.round((event.loaded / event.total) * 100);

        if (percent < 100) {
          entry.progress(percent);
        }
      }
    });

    xhr.open('PUT', url, true);

    for (let prop in headers) {
      xhr.setRequestHeader(prop, headers[prop]);
    }

    xhr.send(entry.file);
  });
};

export default S3Uploader;
